




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { XvUserOrdersResp_Order, InternalStatus } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'

@Component({ components: { PulseLoader } })
export default class XvUserOrders extends Vue {
  public orders!: XvUserOrdersResp_Order[]
  public loaded = false
  public blocked = false
  public InternalStatus = InternalStatus

  @Prop(String) userID!: string

  mounted () {
    const userID = helpers.getAmount(this.userID)

    auth.adminClient().XvUserOrders({ userId: BigInt(userID) }).then((resp) => {
      this.orders = resp.orders
    }).finally(() => {
      this.loaded = true
    })
  }
}
